import { useState } from "react"
import { useTranslation } from "react-i18next"
import { IoIosArrowBack } from "react-icons/io"
import { FiSearch } from "react-icons/fi"
import { useNavigate } from "react-router-dom"
import { FaUserFriends } from "react-icons/fa";
import { IoBookmarks } from "react-icons/io5";
import { GiPresent } from "react-icons/gi";
import { useProfileStore } from "../../store/useUserStore"


const VoucherList = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [searchCode, setSearchCode] = useState("")
    const { selectedVouchers, toggleVoucher } = useProfileStore()

    const siblingVouchers = [
        {
            id: "1",
            type: "Sibling Discount",
            amount: "RM25.96 Off",
            terms: "T&C",
            academy: "Academy Name B",
            description: "Get 10% Discount",
        },
        {
            id: "2", 
            type: "Sibling Discount",
            amount: "RM25.96 Off",
            terms: "T&C",
            academy: "Academy Name Baby Shark",
            description: "Get 10% Discount",
        }
    ]

    // Add this data for bundle vouchers
    const bundleVouchers = [
        {
            id: "bundle1",
            type: "Bundle Discount",
            amount: "RM295 Off",
            terms: "T&C",
            academy: "Your Art Space",
            description: "Amazing Course Bundle",
            recommended: true
        },
        {
            id: "bundle2", 
            type: "Bundle Discount",
            amount: "RM295 Off",
            terms: "T&C",
            academy: "Your Art Space",
            description: "[Bundle Name]",
            recommended: true
        }
    ]

    
    // Add this data for bundle vouchers
    const promoVouchers = [
        {
            id: "bundle3",
            type: "Promotion Discount",
            amount: "RM295 Off",
            terms: "T&C",
            academy: "Your Art Space",
            description: "Amazing Course Bundle",
            recommended: true
        },
        {
            id: "bundle4", 
            type: "Promotion Discount",
            amount: "RM295 Off",
            terms: "T&C",
            academy: "Your Art Space",
            description: "[Bundle Name]",
            recommended: true
        }
    ]

    return (
        <div className="pb-28">
            <div className='mb-2 grid grid-cols-4 px-2'>
                <div><IoIosArrowBack size={28} color='#000' onClick={()=> navigate('/cart')}/></div>
                <div className='text-center col-span-2 text-lg font-medium'>{t('voucher.voucher_discount')}</div>
                <div></div>
            </div>

            {/* Search Bar */}
            <div className="px-4 my-6">
                <div className="flex gap-2">
                    <input
                        type="text"
                        value={searchCode}
                        onChange={(e) => setSearchCode(e.target.value)}
                        placeholder={t('voucher.enter_promo_code')}
                        className="flex-1 px-4 py-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-theme"
                    />
                    <button 
                        className="px-4 py-3 bg-theme text-white rounded-lg hover:bg-opacity-90 transition-colors flex items-center justify-center"
                        onClick={() => {
                            // Handle search functionality here
                            console.log("Searching for:", searchCode);
                        }}
                    >
                        <FiSearch className="w-5 h-5" />
                    </button>
                </div>
            </div>

            {/* Voucher Section */}
            <div className="px-4">
                <h2 className="text-lg font-semibold mb-4">{t('voucher.mykoku_sibling_discount')}</h2>
                
                {siblingVouchers.map((voucher) => (
                    <div key={voucher.id} className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4 overflow-hidden">
                        <div className="flex">
                            {/* Left Icon Section */}
                            <div className="bg-red-500 text-white p-4 flex flex-col items-center justify-center min-w-[100px]">
                                <FaUserFriends size={40} />
                                <div className="text-xs font-semibold text-center leading-tight">
                                    {voucher.type}
                                </div>
                            </div>

                            {/* Right Content Section */}
                            <div className="flex-1 p-4 flex justify-between items-center">
                                <div className="flex-1">
                                    <div className="flex items-center mb-2">
                                        <span className="text-lg font-semibold mr-2">{voucher.amount}</span>
                                        <span className="text-blue-500 text-sm font-medium">{voucher.terms}</span>
                                    </div>
                                    <div className="inline-block bg-white text-theme border-theme border-2  px-3 py-1 rounded-full text-sm mb-2">
                                        {voucher.academy}
                                    </div>
                                    <p className="text-gray-600 text-sm">{voucher.description}</p>
                                </div>

                                {/* Checkbox */}
                                <div className="ml-4">
                                    <button
                                        onClick={() => toggleVoucher(voucher)}
                                        className={`w-6 h-6 rounded border-2 flex items-center justify-center ${
                                            selectedVouchers.find(v => v.id === voucher.id)
                                                ? 'bg-theme border-theme text-white'
                                                : 'border-gray-300'
                                        }`}
                                    >
                                        {selectedVouchers.find(v => v.id === voucher.id) && (
                                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Show More Button */}
                <div className="text-center mt-4">
                    <button className="text-gray-600 font-medium">
                        {t('voucher.show_more')} ∨
                    </button>
                </div>
            </div>



            <div className="px-4">
                {/* Bundle Discount Section */}
                <h2 className="text-lg font-semibold mb-4 mt-8">{t('voucher.mykoku_course_bundle')}</h2>
                
                {bundleVouchers.map((voucher) => (
                    <div key={voucher.id} className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4 overflow-hidden relative">
                        {/* Recommended Badge */}
                        {voucher.recommended && (
                            <div className="absolute top-3 right-3 z-10">
                                <div className="bg-green-400 text-white px-3 py-1 text-xs font-semibold rounded-full">
                                    {t('voucher.recommended')}
                                </div>
                            </div>
                        )}
                        
                        <div className="flex">
                            {/* Left Icon Section - Orange for Bundle */}
                            <div className="bg-orange-500 text-white p-4 flex flex-col items-center justify-center min-w-[100px]">
                                <div className="flex flex-col items-center">
                                    <IoBookmarks size={40} />
                                </div>
                                <div className="text-xs font-semibold text-center leading-tight mt-2">
                                    {voucher.type}
                                </div>
                            </div>

                            {/* Right Content Section */}
                            <div className="flex-1 p-4 flex justify-between items-center">
                                <div className="flex-1">
                                    <div className="flex items-center mb-2">
                                        <span className="text-lg font-semibold mr-2">{voucher.amount}</span>
                                        <span className="text-blue-500 text-sm font-medium">{voucher.terms}</span>
                                    </div>
                                    <div className="inline-block bg-white text-theme border-theme border-2 px-3 py-1 rounded-full text-sm mb-2">
                                        {voucher.academy}
                                    </div>
                                    <p className="text-gray-600 text-sm">{voucher.description}</p>
                                </div>

                                {/* Checkbox */}
                                <div className="ml-4">
                                    <button
                                        onClick={() => toggleVoucher(voucher)}
                                        className={`w-6 h-6 rounded border-2 flex items-center justify-center ${
                                            selectedVouchers.find(v => v.id === voucher.id)
                                                ? 'bg-theme border-theme text-white'
                                                : 'border-gray-300'
                                        }`}
                                    >
                                        {selectedVouchers.find(v => v.id === voucher.id) && (
                                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Show More Button */}
                <div className="text-center mt-4">
                    <button className="text-gray-600 font-medium">
                        {t('voucher.show_more')} ∨
                    </button>
                </div>
            </div>



            <div className="px-4">
                {/* Bundle Discount Section */}
                <h2 className="text-lg font-semibold mb-4 mt-8">{t('voucher.mykoku_course_bundle')}</h2>
                
                {promoVouchers.map((voucher) => (
                    <div key={voucher.id} className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4 overflow-hidden relative">
                        {/* Recommended Badge */}
                        {voucher.recommended && (
                            <div className="absolute top-3 right-3 z-10">
                                <div className="bg-green-400 text-white px-3 py-1 text-xs font-semibold rounded-full">
                                    {t('voucher.recommended')}
                                </div>
                            </div>
                        )}
                        
                        <div className="flex">
                            {/* Left Icon Section - Blue for Promo */}
                            <div className="bg-blue-500 text-white p-4 flex flex-col items-center justify-center min-w-[100px]">
                                <div className="flex flex-col items-center">
                                    <GiPresent size={40} />
                                </div>
                                <div className="text-xs font-semibold text-center leading-tight mt-2">
                                    {voucher.type}
                                </div>
                            </div>

                            {/* Right Content Section */}
                            <div className="flex-1 p-4 flex justify-between items-center">
                                <div className="flex-1">
                                    <div className="flex items-center mb-2">
                                        <span className="text-lg font-semibold mr-2">{voucher.amount}</span>
                                        <span className="text-blue-500 text-sm font-medium">{voucher.terms}</span>
                                    </div>
                                    <div className="inline-block bg-white text-theme border-theme border-2 px-3 py-1 rounded-full text-sm mb-2">
                                        {voucher.academy}
                                    </div>
                                    <p className="text-gray-600 text-sm">{voucher.description}</p>
                                </div>

                                {/* Checkbox */}
                                <div className="ml-4">
                                    <button
                                        onClick={() => toggleVoucher(voucher)}
                                        className={`w-6 h-6 rounded border-2 flex items-center justify-center ${
                                            selectedVouchers.find(v => v.id === voucher.id)
                                                ? 'bg-theme border-theme text-white'
                                                : 'border-gray-300'
                                        }`}
                                    >
                                        {selectedVouchers.find(v => v.id === voucher.id) && (
                                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Show More Button */}
                <div className="text-center mt-4">
                    <button className="text-gray-600 font-medium">
                        {t('voucher.show_more')} ∨
                    </button>
                </div>
            </div>


        </div>
    )
}

export default VoucherList